"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectCard = void 0;
const vue_1 = require("vue");
const Button_1 = require("../components/common/Button");
const CardOrderStorage_1 = require("./CardOrderStorage");
const Card_1 = require("./card/Card");
const ActiveCardsSortingOrder_1 = require("../components/ActiveCardsSortingOrder");
const TranslateMixin_1 = require("./TranslateMixin");
exports.SelectCard = vue_1.default.component('select-card', {
    props: {
        player: {
            type: Object,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            cards: [],
            warning: undefined,
        };
    },
    components: {
        Card: Card_1.Card,
        Button: Button_1.Button,
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    watch: {
        cards: function () {
            this.$emit('cardschanged', this.getData());
        },
    },
    methods: {
        cardsSelected: function () {
            if (Array.isArray(this.cards)) {
                return this.cards.length;
            }
            else if (this.cards === false || this.cards === undefined) {
                return 0;
            }
            return 1;
        },
        getOrderedCards: function () {
            if (this.playerinput.cards === undefined) {
                return [];
            }
            if (this.playerinput.selectBlueCardAction) {
                return ActiveCardsSortingOrder_1.sortActiveCards(this.playerinput.cards);
            }
            else {
                return CardOrderStorage_1.CardOrderStorage.getOrdered(CardOrderStorage_1.CardOrderStorage.getCardOrder(this.player.id), this.playerinput.cards);
            }
        },
        hasCardWarning: function () {
            if (Array.isArray(this.cards)) {
                return false;
            }
            else if (typeof this.cards === 'object' && this.cards.warning !== undefined) {
                this.warning = this.cards.warning;
                return true;
            }
            return false;
        },
        isOptionalToManyCards: function () {
            return this.playerinput.maxCardsToSelect !== undefined &&
                this.playerinput.maxCardsToSelect > 1 &&
                this.playerinput.minCardsToSelect === 0;
        },
        getData: function () {
            return Array.isArray(this.$data.cards) ? this.$data.cards.map((card) => card.name) : [this.$data.cards.name];
        },
        saveData: function () {
            this.onsave([this.getData()]);
        },
        getCardBoxClass: function (card) {
            if (this.playerinput.showOwner && this.getOwner(card) !== undefined) {
                return 'cardbox cardbox-with-owner-label';
            }
            return 'cardbox';
        },
        getOwner: function (card) {
            for (const player of this.player.players) {
                if (player.playedCards.find((c) => c.name === card.name) || player.corporationCards.some((corp) => corp.name === card.name)) {
                    return { name: player.name, color: player.color };
                }
            }
            return undefined;
        },
        robotCard(card) {
            var _a;
            return (_a = this.player.selfReplicatingRobotsCards) === null || _a === void 0 ? void 0 : _a.find((r) => r.name === card.name);
        },
    },
    template: `<div class="wf-component wf-component--select-card">
        <div v-if="showtitle === true" class="nofloat wf-component-title">{{ $t(playerinput.title) }}</div>
        <label v-for="card in getOrderedCards()" :key="card.name" :class="getCardBoxClass(card)">
            <template v-if="!card.isDisabled">
              <input v-if="playerinput.maxCardsToSelect === 1 && playerinput.minCardsToSelect === 1" type="radio" v-model="cards" :value="card" />
              <input v-else type="checkbox" v-model="cards" :value="card" :disabled="playerinput.maxCardsToSelect !== undefined && Array.isArray(cards) && cards.length >= playerinput.maxCardsToSelect && cards.includes(card) === false" />
            </template>
            <Card v-if="playerinput.showOwner && getOwner(card) !== undefined" :card="card" :owner="getOwner(card)" :robotCard="robotCard(card)"/>
            <Card v-else :card="card" :robotCard="robotCard(card)"/>
        </label>
        <div v-if="hasCardWarning()" class="card-warning">{{ $t(warning) }}</div>
        <div v-if="showsave === true" class="nofloat">
            <Button :disabled="isOptionalToManyCards() && cardsSelected() === 0" type="submit" :onClick="saveData" :title="playerinput.buttonLabel" />
            <Button :disabled="isOptionalToManyCards() && cardsSelected() > 0" v-if="isOptionalToManyCards()" :onClick="saveData" type="submit" :title="$t('Skip this action')" />
        </div>
    </div>`,
});
//# sourceMappingURL=SelectCard.js.map